export enum AvailableCountriesList {
  ARG = 'ARG',
  AUS = 'AUS',
  BRA = 'BRA',
  CAN = 'CAN',
  COL = 'COL',
  DEU = 'DEU',
  ESP = 'ESP',
  FRA = 'FRA',
  GBR = 'GBR',
  IND = 'IND',
  ITA = 'ITA',
  MEX = 'MEX',
  PHL = 'PHL',
  POL = 'POL',
  // RUS = 'RUS',
  TUR = 'TUR',
  UKR = 'UKR',
  USA = 'USA',
  all = 'all',
}

export enum FullCountriesNames {
  ARG = 'Argentina',
  AUS = 'Australia',
  BRA = 'Brazil',
  CAN = 'Canada',
  COL = 'Colombia',
  DEU = 'Germany',
  ESP = 'Spain',
  FRA = 'France',
  GBR = 'United Kingdom',
  IND = 'India',
  ITA = 'Italy',
  MEX = 'Mexico',
  PHL = 'Philippines',
  POL = 'Poland',
  // RUS = 'Russia',
  TUR = 'Turkey',
  UKR = 'Ukraine',
  USA = 'United States',
  all = 'All Regions',
}
